<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-envelope"></i> Tickets</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column">
                <tickets-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="tickets" v-bind:actions="true"></tickets-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import TicketRepo from '../../repos/TicketRepo'
import lodash from 'lodash'
import TicketsTable from "./Table";

export default {
  name: 'tickets-view',
  components: {TicketsTable},
  data() {
        return {
            repo: new TicketRepo(this.$auth),
            tickets: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getUsers();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getUsers();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getUsers();
    },
    onPageChanged(page){
        this.page = page;        
        this.getUsers();
    },
    getUsers(){
        this.repo.paginate(this.page, this.q, this.orderBy).then(response => {            
            this.tickets = response.data.data;
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/tickets/View.vue